import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from '../../Transcript/TranscriptStyles';
import { formattedStartAndEndDate,formatInstructorName } from '../../Transcript/TranscriptUtils';

const TranscriptHeader = ({ minDate, maxDate,firstName,lastName,userName,dob }) => (
   


  <View style={styles.header}>
      <Image style={styles.logo} src="/Logo.png" />
  
    <Text style={styles.companyText}>
            SEIU 775 Benefits Group{'\n'}
            215 Columbia St #300, Seattle, WA 98104
          </Text>
          <View style={styles.headerTwoColumn}>
  <View style={styles.hedaerColumn1}>
    <Text style={styles.headertext1}></Text>
    <Text style={styles.headertext1}></Text>
    <Text style={styles.headertext1}></Text>
    <Text style={styles.headertext1}></Text>
      <View style={styles.headertextOfficialColumn}><Text style={styles.headertextOfficial}>Official Training Transcript  </Text>
      {/* <Text style={styles.headertextOfficialtext}> {formattedStartAndEndDate(minDate)} through {formattedStartAndEndDate(maxDate)} ‡</Text> */}
     </View> 
    </View>
    <View style={[styles.hedaerColumn2,{alignSelf: 'flex-end'}]}>
      <Text style={styles.headertext1}>Learner Name:&nbsp;{formatInstructorName(firstName)} {formatInstructorName(lastName)}</Text>
      <Text style={styles.headertext1}>Learner ID:&nbsp; &nbsp; &nbsp; &nbsp;{userName}</Text>
      <Text style={styles.headertext1}>Learner DOB:&nbsp; &nbsp;{formattedStartAndEndDate(dob) !== 'NaN/NaN/NaN' ? formattedStartAndEndDate(dob) : ''}
</Text>
        
    </View>
    </View>
    </View>
);

export default TranscriptHeader;
